var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import UISwitch from '../../../ui/components/web/Switch';
/**
 * Renders a boolean input.
 */
export default class Switch extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const _a = this.props, { className, disabled, onValueChange, value, id } = _a, props = __rest(_a, ["className", "disabled", "onValueChange", "value", "id"]);
        return (React.createElement("div", { className: className },
            React.createElement(UISwitch, Object.assign({ checked: value, disabled: disabled, id: id, onChange: onValueChange }, props))));
    }
}
